import React from 'react';
import config from '../../common/config.js';
import Media from 'react-media'
import { apiService } from '../../common/apiCallService';
import DesktopReplayer from './DesktopReplayer.js'
import MobileReplayer from './MobileReplayer.js'
import Loading from '../Loading.js';
import moment from 'moment';
import { saveActivity } from '../../common/commonService.js'

// import GridDemo from './GridDemo.js'
//commit
let baseUrl = "//" + config.domain + "/images"
let emptySeat = baseUrl + "/replayerIcons/seat.png"
let heroSeat = baseUrl + "/replayerIcons/hero.png"
let heroFocus = baseUrl + "/replayerIcons/heroFocus.png"
let heroFolds = baseUrl + "/replayerIcons/heroFolds.png"
let playerSeat = baseUrl + "/replayerIcons/player.png"
let playerFolds = baseUrl + "/replayerIcons/playerFolds.png"
let playerFocus = baseUrl + "/replayerIcons/playerFocus.png"
let chipsImage = baseUrl + "/pokerChips"
let onNameFocus = { backgroundColor: '#DE460F', marginBottom: '7%', minWidth: '80px', fontSize: "90%", textAlign: 'center', borderRadius: '5px', boxShadow: '1px 3px 5px #000' }
let lostNameFocus = { backgroundColor: '#5F5E67', marginBottom: '7%', minWidth: '80px', fontSize: "90%", textAlign: 'center', borderRadius: '5px', boxShadow: '1px 3px 5px #000', fontFamily: "Helvetica Neue", color: "#FFFFFF", letterSpacing: "0.03px" }
let onAmountFocus = { backgroundColor: '#f38258', textAlign: 'center', minWidth: '80px', fontSize: "90%", borderRadius: '5px', color: 'white' }
let lostAmountFocus = { backgroundColor: '#5F5E67', textAlign: 'center', minWidth: '80px', fontSize: "90%", borderRadius: '5px', color: 'black', fontFamily: "Roboto", color: "#FFFFFF" }
let winnerFocus = { backgroundColor: 'green', textAlign: 'center', padding: '2%', borderRadius: '5px', color: 'white' }
var boosterImages = {
  gold: {
    amount: "gold_booster_amount_2px.png",
    normal: "gold_booster_2px.png"
  },
  silver: {
    amount: "silver_booster_amount_2px.png",
    normal: "silver_booster_2px.png"
  },
  bronze: {
    amount: "bronze_booster_amount_2px.png",
    normal: "bronze_booster_2x.png"
  }
};
export default class HandReplayer extends React.Component {
  constructor(props) {
  //  console.log("HandReplayer//////////////")

    super(props);
    this.state = {
      shareURL: `${config.domain}/replayer/`,
      shareType: 'handreplayer',
      shareDialog: false,
      loading: true,
      tableImage: baseUrl + "/replayerElements/newTable.png",
      playIcon: baseUrl + "/replayerElements/play.png",
      pauseIcon: baseUrl + "/replayerElements/pause.png",
      replay: baseUrl + "/replayerElements/replay.png",
      backward: baseUrl + "/replayerElements/backward.png",
      forward: baseUrl + "/replayerElements/forward.png",
      dealerButton: baseUrl + "/pokerChips/dealerButton.png",
      playerAlias: '',
      gameNo: '',
      allinseats: [],
      lowEndChips: [0.25, 0.05, 0.01],
      highEndChips: [5000000, 500000, 100000, 25000, 5000, 1000, 500, 100, 25, 5, 1],
      lostPlayers: [],
      wonPlayers: [],
      rePlayerData: {
        slideIndex: 0,
        playStatus: false,
        currenSlide: {},
        slides: []
      },
      replayerSpeed: 2000,
      allBlinds: '',
      smallBlind : 0,
      bigBlind: 0,
      timeoutStp: {},
      isShareDialogOpen : false,
      booster:"N",
      boosterAmount:0,
      boosterType:'',
      currency:'USD'
    }

    this.refresh = this.refresh.bind(this);
    this.stepBackward = this.stepBackward.bind(this);
    this.play = this.play.bind(this);
    this.pause = this.pause.bind(this);
    this.stepForward = this.stepForward.bind(this);
    this.onShareDialogOpen = this.onShareDialogOpen.bind(this);
    this.onShareDialogClose = this.onShareDialogClose.bind(this);
  }

  getShareLink = () => {
    return config.domain + "/replayer/";
  }
  componentWillUnmount() {
    this.state.rePlayerData = {}
    this.forceUpdate()
  }

  setUpReplayerData = (gameNo, playerAlias,accountName,fromDate,toDate,gameType,partitionDate) => {
    apiService(config.baseUrl + '/pokerWatch/handReplayer',
      { gameNo, playerAlias,fromDate,toDate,gameType,partitionDate,accountName},
      (data) => {
        let actionDtls = [];
        let sbFlag = 0;
//console.log('setUpReplayerData............',data)
        this.setState({ 
          currency:data.currency,
          allBlinds: data.gameDtls.gameInfo_blinds_small + '/' + data.gameDtls.gameInfo_blinds_big,
          smallBlind : data.gameDtls.gameInfo_blinds_small,
          bigBlind: data.gameDtls.gameInfo_blinds_big,
          booster:data.booster || 'N',
          boosterAmount:data.boosterAmount||0,
          boosterType:data.boosterType || ''
        })

        data.actionDtlsList.map((action) => {
          // console.log("------------cards------------",action.cards)
          if (action.action == 'smallBlind') sbFlag++
          if (sbFlag <= 1) actionDtls.push(action)
        })
        this.processRawData(data.handSummary);
        this.setState({ playerList: JSON.parse(JSON.stringify(data.playerDtlsList)) },
          () => {
            this.generateSlides(data.playerDtlsList, actionDtls, data.playerAlias)
            let { rePlayerData } = this.state;
            rePlayerData.currentSlide = JSON.parse(JSON.stringify(rePlayerData.slides[0]));
            setTimeout(() => {
              this.setState({ loading: false });
              this.play()
            }, 1000);
          }
        );

      }, (data) => {
        this.setState({ playFlag: true })
        if (data.status == 403) {
          this.setState({ loginRedirect: true })
        }
        this.setState({ loading: false })
      })
  }

  componentWillMount() {
  //  console.log("Mounted::")
    let clonedProps = JSON.parse(JSON.stringify(this.props));
    this.setUpReplayerData(clonedProps.gameNo, clonedProps.playerAlias,clonedProps.accountName,
      clonedProps.fromDate, clonedProps.toDate, clonedProps.gameType, clonedProps.partitionDate);
  }

  processRawData = (handSummary) => {
    this.state.lostPlayers = []
    this.state.wonPlayers = []

    // let summaryData = rawData.handHistory.split('** Summary **')[1]
    // let summaryLines = summaryData.split('#*#');
    handSummary.map((line) => {
      //console.log(line);
      if (line.indexOf('collected') !== -1 && line.indexOf('lost') === -1) {
        let temp = {}
        temp.name = line.split('balance')[0].trim()
        temp.collectedAmt = Number(/(\d+\.?\d*)/g.exec(line.split('collected ')[1])[1].trim())
        if (line.indexOf('] [') !== -1) temp.cardDtls = /\[(.*)]/g.exec(line)[1].trim().split('] [')[1]
        this.state.wonPlayers.push(temp)
      } else if (line.indexOf('lost') !== -1 && line.indexOf('] [') !== -1) {
        let temp = {}
        temp.name = line.split('balance')[0].trim()
        temp.lostAmt = Number(/(\d+\.?\d*)/g.exec(line.split('lost ')[1])[1].trim())
        temp.collectedAmt = 0
        if (line.indexOf('collected') !== -1) temp.collectedAmt = Number(/(\d+\.?\d*)/g.exec(line.split('collected ')[1])[1].trim())
        if (line.indexOf('] [') !== -1) temp.cardDtls = /\[(.*)]/g.exec(line)[1].trim().split('] [')[1]
        this.state.lostPlayers.push(temp)
      }
    })
  }

  getCoins = (playerAmt) => {
    let finalChips = []
    let beforeDec = parseInt(playerAmt.toString().split('.')[0])
    let afterDec = parseFloat("0." + playerAmt.toString().split('.')[1])
    let index = 0

    if (beforeDec > 0) {
      this.state.highEndChips.map((chip) => {
        if (beforeDec >= chip) {
          let temp = {}
          temp['chip' + index] = []
          let remChips = beforeDec % chip
          let pokerChip
          if (remChips == 0) {
            pokerChip = beforeDec / chip
            beforeDec = 0
          } else {
            pokerChip = beforeDec - remChips
            pokerChip = pokerChip / chip
            beforeDec = remChips
          }
          let i = 0
          while (i < pokerChip) {
            temp['chip' + index].push(chipsImage + '/' + chip + '.png')
            i++
          }
          finalChips.push(temp)
          index++
        }
      })
    }

    if (afterDec > 0) {
      this.state.lowEndChips.map((chip) => {
        if (afterDec >= chip) {
          let temp = {}
          temp['chip' + index] = []
          let remChips = afterDec % chip
          let pokerChip
          if (remChips == 0) {
            pokerChip = afterDec / chip
            afterDec = 0
          } else {
            remChips = remChips.toFixed(2)
            remChips = parseFloat('0.' + remChips.toString().split('.')[1].substring(0, 2))
            pokerChip = afterDec - remChips
            pokerChip = pokerChip / chip
            pokerChip = pokerChip.toFixed(2)
            afterDec = remChips
          }
          let i = 0
          while (i < pokerChip) {
            temp['chip' + index].push(chipsImage + '/' + chip + '.png')
            i++
          }
          finalChips.push(temp)
          index++
        }
      })
    }
    return finalChips
  }

  compressActionList = (actionDtlsList) => {
    // let compressedActionList = [];
    // let showflag = 0;
    let playerList = JSON.parse(JSON.stringify(this.state.playerList));
    function groupActionsBySequence(actionDtlsList, property) {
      return actionDtlsList.reduce(function (acc, obj) {
        if (acc[obj.sequence]) {
          acc[obj.sequence].cards = `${acc[obj.sequence].cards},${obj.cards}`
        } else {
          acc[obj.sequence] = obj;
        }
        return acc;
      }, {});
    }


    var groupActions = groupActionsBySequence(actionDtlsList, 'sequence');
    // let compressedActionList = Object.values(groupActions)
    let compressedActionList = Object.keys(groupActions).map(e => groupActions[e])

    compressedActionList.map((action) => {
      if (action.action == 'show') {
        playerList.map((player) => {
          if (player.name == action.actor && player.name != this.state.playerAlias) {
            if (player.cards == null) player.cards = `${action.cards}`;
            else player.cards = `${player.cards}`
          }
        })
      }
    })
    // let playerList = JSON.parse(JSON.stringify(this.state.playerList));
    // // debugger;
    // actionDtlsList.map((action) => {
    //   action.showFlag = false
    //   if(action.action == 'hole cards' || action.action == 'flop' || action.action == 'show' || action.action == 'not show') {
    //     let seqIndex = compressedActionList.findIndex((CA) =>CA.sequence == action.sequence);
    //     if(seqIndex != -1) {
    //       compressedActionList[seqIndex].cards = `${compressedActionList[seqIndex].cards}, ${action.cards}`
    //     } else {
    //       compressedActionList.push(action);
    //     }
    //     if(action.action == 'show') {
    //       playerList.map((player) => {
    //         if(player.name == action.actor && player.name != this.state.playerAlias) {
    //           if(player.cards == null) player.cards = `${action.cards}`;
    //           else player.cards = `${player.cards},${action.cards}`
    //         }
    //       })
    //     }
    //   } else {
    //     // if(action.action == 'allIn') {
    //     //   if(showflag == 0) showflag = 1;
    //     //   else if(showflag == 1) {
    //     //     action.showFlag = true
    //     //     showflag = -1;
    //     //   }
    //     // }
    //     compressedActionList.push(action);
    //   }

    // })
    // if(showflag == -1) console.log("--<its an ALLIN Game>--");
    // else console.log("--<its a NOT an ALLIN Game>--");

    // if(showflag == -1) {
    //   compressedActionList = compressedActionList.filter(listitem => listitem.action != 'show')
    // }
    let updateFlag = true;
    this.state.playerList = playerList;
    // this.setState({playerList})
    this.forceUpdate();
    return compressedActionList;
  }

  generateSlides = (initPlayerList, initActionList, playerAlias) => {
    this.addSlide(this.generateFirstSlide(initPlayerList, playerAlias));
    let processedActionList = this.compressActionList(JSON.parse(JSON.stringify(initActionList)));
    processedActionList.map((action) => { this.addSlide(this.convertActionToSlide(action)) })
    // console.log("No of slides after action to slide conversion : ", this.state.rePlayerData.slides.length);
    // console.log(this.state.rePlayerData.slides);
    this.addSlide(this.generateLastSlide(this.state.lostPlayers, this.state.wonPlayers, this.getLastSlide()));
    // console.log("No of slides", this.state.rePlayerData.slides.length);
  }

  continue = () => {
    this.state.timeoutStp = setTimeout(() => {
      // console.log("this.state.replayerSpeed",this.state.replayerSpeed)
      if (this.state.rePlayerData.playStatus) {
        this.nextSlide();
        this.continue()
      }
    }, this.state.replayerSpeed)
  }

  onShareDialogOpen = () => {
    this.pause();
    // console.log("opening Dialog");
    this.setState({ shareDialog: true });
  }

  onShareDialogClose = () => {
    this.play();
    // console.log("closing dialog");
    this.setState({ shareDialog: false });
  }
  next = () => {
    this.pause();
    this.nextSlide();
  }

  refresh = () => {
    clearTimeout(this.state.timeoutStp);
    this.setState({ replayerSpeed: 2000 })
    this.pause();
    let { rePlayerData } = this.state;
    rePlayerData.slideIndex = 0;
    rePlayerData.currentSlide = JSON.parse(JSON.stringify(rePlayerData.slides[rePlayerData.slideIndex]))
    this.setState(rePlayerData);
    this.play();
  }

  //rePlayer Methods

  generateEmptySlide = () => {
    let slide = {}
    slide = {
      dealerCards: [],
      pot: this.generateCoins(0),
      description: '',
      seats: [],
      slideID: 0
    }
    for (let i = 0; i < 10; i++) {
      let isActive = false
      let name = 'No Player'
      let alias = ''
      let display = {
        text: name,
        style: {}
      }

      let coinStack = {
        amount: 0,
        imgUrls: this.getCoins(0),
        style: {}
      }

      let tableStack = {
        amount: 0,
        imgStack: this.getCoins(0),
        style: {}
      }

      let cards = [];

      let displayPicture = emptySeat;


      let dealer = false;

      slide.seats.push({
        alias,
        isActive,
        name,
        dealer,
        display,
        coinStack,
        tableStack,
        cards,
        displayPicture
      });
    }
    return slide
  }

  getSeatNumbers = (count) => {
    let seatNos = []
    if (count < 6) {
      let seatDiff = Math.floor(10 / count)
      for (let i = 0; i <= 9; i = i + seatDiff) {
        seatNos.push(i)
      }
    } else if (count == 6) seatNos = [0, 1, 3, 4, 6, 8]
    else seatNos = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
    return seatNos
  }

  generateFirstSlide = (playerList, playerAlias) => {
    let slide = {}
    slide = {
      dealerCards: [],
      pot: this.generateCoins(0),
      hiddenPot: this.generateCoins(0),
      description: '',
      seats: [],
      slideID: 1
    }
    let idx = 0
    let seatNos = this.getSeatNumbers(playerList.length)
    let players = []
    playerList.map(player => {
      players[seatNos[idx]] = player
      idx++
    })
    playerList = players
    let playerIndx = 1
    for (let i = 0; i < 10; i++) {
      if (playerList[i]) {
        let currentPlayer = playerList[i];
        let isActive;
        isActive = false;

        let alias = currentPlayer.name;

        let name;
        if (currentPlayer.name == playerAlias) name = "Hero"
        else name = 'Player ' + (playerIndx);

        let dealer;
        if (currentPlayer.btnSeat == currentPlayer.seat) dealer = true
        else dealer = false

        let display = {
          text: name,
          style: lostNameFocus
        }
        let coinStack = {
          amount: currentPlayer.startStack,
          imgStack: this.getCoins(currentPlayer.startStack),
          style: lostAmountFocus
        }

        let tableStack = {
          amount: 0,
          imgStack: this.getCoins(0),
          style: {}
        };

        let cards = [];

        let displayPicture;
        if (name == "Hero") displayPicture = heroSeat;
        else {
          if(coinStack.amount > 0)
            displayPicture = playerSeat;
          else
            displayPicture = playerFolds;
        }

        slide.seats.push({
          alias,
          isActive,
          name,
          dealer,
          display,
          coinStack,
          tableStack,
          cards,
          displayPicture
        });
        playerIndx++
      } else {
        let curPlayer = playerList[i];
        let isActive = false

        let name = ''
        let alias = ''
        let display = {
          text: name,
          style: {}
        }

        let coinStack = {
          amount: "",
          imgUrls: this.getCoins(0),
          style: {}
        }

        let tableStack = {
          amount: 0,
          imgStack: this.getCoins(0),
          style: {}
        }

        let cards = [];

        let displayPicture = "";


        let dealer = false;

        slide.seats.push({
          alias,
          isActive,
          name,
          dealer,
          display,
          coinStack,
          tableStack,
          cards,
          displayPicture
        });
      }
    }
    return slide
  }

  generateCoins(amount, style = {}) {
    return { amount: parseFloat(amount), imgStack: this.getCoins(amount), style: style }
  }

  convertActionToSlide = (action) => {
    //console.log(action);
    let workingSlide = this.getLastSlide();
    let index = this.getSeatIndexByName(workingSlide.seats, action.actor);

    this.deactivateSeat(workingSlide);
    this.upadateDescription(workingSlide, index, action);
    workingSlide.action = action.action;
    workingSlide.slideID = workingSlide.slideID + 1;
    if (action.action == 'hole cards') {
      workingSlide = this.setHoleCards(workingSlide, action.cards);
    } else if (action.action == 'flop' || action.action == 'river' || action.action == 'turn') {
      workingSlide.pot = this.generateCoins(workingSlide.hiddenPot.amount.toFixed(2));
      workingSlide.dealerCards = this.getCards(action.cards, workingSlide.dealerCards);
      workingSlide.seats.map((seat) => {
        seat.tableStack = this.generateCoins(0);
      })
    } else if (action.action == 'not show') {
      return null;
    } 
    /*** show opponents hole cards  at the end of the game don't show at the time of all-in */
    //  else if (action.action == 'allIn') {
      // workingSlide = this.activateSeat(workingSlide, index, action.action);
      // let playerindex = this.state.playerList.findIndex(player => player.name == action.actor)
      // this.state.playerList[playerindex].allInflag = true;
      // if (this.state.playerList.filter(player => player.allInflag == true).length >= 2) {
      //   this.state.playerList.map(player => {
      //     if (player.cards && player.allInflag == true) workingSlide.seats[this.getSeatIndexByName(workingSlide.seats, player.name)].cards = this.getCards(player.cards);
      //   })
      // }
    // } 
    else if (action.action == 'check') {
      workingSlide = this.activateSeat(workingSlide, index, action.action);
    } else {
      workingSlide = this.activateSeat(workingSlide, index, action.action);
      if (action.action == 'show') {
        if (workingSlide.seats[index].name == 'Hero') {
          return null;
        } else {
          if (this.state.playerList.filter(player => player.allInflag == true).length >= 2) {
            let actorDetails = this.state.playerList.find(player => player.name == action.actor);
            if (actorDetails.allInflag) return null
            else workingSlide.seats[index].cards = this.getCards(action.cards);
          } else {
            workingSlide.seats[index].cards = this.getCards(action.cards);
          }
        }
      } else if (action.action == 'fold') {
        workingSlide.seats[index].cards = []
        workingSlide.seats[index].displayPicture = playerFolds
      } else {
        let hiddenPot = workingSlide.hiddenPot.amount + action.amount;
        workingSlide.hiddenPot = this.generateCoins(hiddenPot.toFixed(2))

        let currentCoins = workingSlide.seats[index].coinStack.amount - action.amount;
        workingSlide.seats[index].coinStack = this.generateCoins(currentCoins.toFixed(2), onAmountFocus);

        let tableCoins = workingSlide.seats[index].tableStack.amount + action.amount;
        workingSlide.seats[index].tableStack = this.generateCoins(tableCoins.toFixed(2));
      }
    }
    return workingSlide;
  }

  upadateDescription = (workingSlide, index, action) => {

    let amtDescp = ''
    if (action.amount != null) amtDescp = action.amount

    let currDescp = ''
    if (index == -1) currDescp = '\n' + 'Dealer' + ': ' + action.action + " " + amtDescp
    else currDescp = '\n' + workingSlide.seats[index].name + ': ' + action.action + " " + amtDescp

    if (action.cards && action.action != 'not show') currDescp = currDescp + ' ' + action.cards

    workingSlide.description = workingSlide.description + currDescp
  }

  deactivateSeat = (workingSlide) => {
    let lastActiveSeatIndex = this.getLastActiveSeatIndex(workingSlide);
    if (lastActiveSeatIndex != -1) {
      let lastAction = workingSlide.seats[lastActiveSeatIndex].display.text;
      workingSlide.seats[lastActiveSeatIndex].isActive = false;
      if (workingSlide.seats[lastActiveSeatIndex].name == "Hero") {
        if (lastAction == 'fold') workingSlide.seats[lastActiveSeatIndex].displayPicture = heroFolds;
        else workingSlide.seats[lastActiveSeatIndex].displayPicture = heroSeat;
      } else {
        if (lastAction == 'fold') workingSlide.seats[lastActiveSeatIndex].displayPicture = playerFolds;
        else workingSlide.seats[lastActiveSeatIndex].displayPicture = playerSeat;
      }
      workingSlide.seats[lastActiveSeatIndex].display.style = lostNameFocus;
      workingSlide.seats[lastActiveSeatIndex].display.text = workingSlide.seats[lastActiveSeatIndex].name;
      workingSlide.seats[lastActiveSeatIndex].coinStack.style = lostAmountFocus;
    }
    return workingSlide;
  }

  activateSeat = (workingSlide, index, action) => {
    workingSlide.seats[index].isActive = true;
    workingSlide.seats[index].display = {
      text: action,
      style: onNameFocus
    }
    workingSlide.seats[index].coinStack.style = onAmountFocus;
    if (workingSlide.seats[index].name == 'Hero') {
      workingSlide.seats[index].displayPicture = heroFocus
    } else {
      workingSlide.seats[index].displayPicture = playerFocus
    }
    return workingSlide;
  }

  setHoleCards = (workingSlide, cards) => {
    workingSlide.seats.map((seat) => {
      if (seat.name == 'Hero') {
        seat.isActive = true;
        seat.display.text = 'Hole Cards'
        seat.display.style = onNameFocus;
        seat.displayPicture = heroFocus;
        seat.cards = this.getCards(cards);
      } else if (seat.name.substr(0, 6) == 'Player') {

        if (seat.coinStack.amount > 0) {
          if (cards) {
            seat.cards = this.getBackCards(cards.split(',').length);
          }
        }
      }
    })
    return workingSlide;
  }

  getLastSlide = () => {
    return JSON.parse(JSON.stringify(this.state.rePlayerData.slides[this.state.rePlayerData.slides.length - 1]))
  }

  getLastActiveSeatIndex = (slides) => {
    // return slides.seats.findIndex((seat) => seat.isActive)
    var index = -1;
    for (var i = 0; i < slides.seats.length; ++i) {
      if (slides.seats[i].isActive) {
          index = i;
          break;
      }
    }
    return index;
  }

  getCards = (cardString, tempCards = []) => {
    // if (cardString.split(',').length == 3) console.log(`%c${cardString}`, 'font-size : 25px');
    cardString
      .split(',')
      .filter(card => card != '')
      .map((card) => {
        let imgUrl = baseUrl + '/cards2x/' + this.getBaseCard(card) + '/' + card.trim() + '.png'
        let imgId = card.trim();
        let style = "{paddingRight:' 0.5em', width: '40%'}";
        tempCards.push({ imgUrl, imgId, style });
      })
    return tempCards;
  }

  getBaseCard = (card) => {
    let cardgroup = ['diamond', 'heart', 'spade', 'club']
    // if (cardgroup.find((ob) => ob.charAt(0) === card.trim().charAt(1)) == undefined) console.log(card);

    // return cardgroup.find((ob) => ob.charAt(0) === card.trim().charAt(1))
    return cardgroup.filter(function (ob) {
      return ob.charAt(0) === card.trim().charAt(1)
    })[0];
  }

  getBackCards = (count) => {
    let tempCards = []
    for (let i = 0; i < count; i++) {
      let imgUrl = baseUrl + '/replayerIcons/backOfCard.png';
      let imgId = 'backOfCard';
      let style = "{paddingRight:' 0.5em', width: '40%'}";
      tempCards.push({ imgUrl, imgId, style });
    }
    return tempCards;
  }

  addSlide = (slide) => {
    if (slide) {
      // console.log(`Adding slide with slide id ${slide.slideID}`);
      let { rePlayerData } = this.state;
      rePlayerData.slides.push(slide);
      this.setState(rePlayerData);
    }
  }

  getSeatIndexByName = (seats, name) => {
    // return seats.findIndex((seat) => seat.alias == name);
    var index= -1;
    for (var i = 0; i < seats.length; ++i) {
      if (seats[i].alias === name) {
          index = i;
          break;
      }
    }
    return index;
  }

  generateLastSlide = (lostPlayers, wonPlayers, slide) => {
    slide.pot = this.generateCoins(0);
    let tempDesc = '';
    this.deactivateSeat(slide);
    lostPlayers.map((player) => {
      let index = this.getSeatIndexByName(slide.seats, player.name);
      slide.seats[index].tableStack = this.generateCoins(player.collectedAmt)
      slide.seats[index].coinStack = this.generateCoins((slide.seats[index].coinStack.amount + player.collectedAmt).toFixed(2), lostAmountFocus);
      tempDesc = `${tempDesc} ${slide.seats[index].name} : lost(${player.lostAmt})${(player.cardDtls != null) ? " with" + player.cardDtls : ""}\n`
    })

    wonPlayers.map((player) => {
      let index = this.getSeatIndexByName(slide.seats, player.name);
      slide.seats[index].tableStack = this.generateCoins(player.collectedAmt)
      slide.seats[index].coinStack = this.generateCoins((slide.seats[index].coinStack.amount + player.collectedAmt).toFixed(2), onAmountFocus);
      slide.seats[index].display.style = onNameFocus;
      this.activateSeat(slide, index, slide.seats[index].display.text)
      tempDesc = `${tempDesc} ${slide.seats[index].name} : won(${slide.seats[index].tableStack.amount})${(player.cardDtls != null) ? " with" + player.cardDtls : ""}`
    })
    slide.description = slide.description + '\n' + tempDesc;
    return slide;
  }

  //playerFunction
  nextSlide = () => {
    let { rePlayerData } = this.state;
    let noOfSlides = rePlayerData.slides.length;
    if (rePlayerData.slides[rePlayerData.slideIndex + 1] && rePlayerData.slides[rePlayerData.slideIndex + 1].action != 'ante') {
      this.setState({ replayerSpeed: 2000 })
    } else {
      this.setState({ replayerSpeed: 800 })
    }
    // console.log(`${rePlayerData.slideIndex} : ${noOfSlides - 1}`);
    if (rePlayerData.slideIndex != (noOfSlides - 1)) {
      rePlayerData.slideIndex++
      for (let i = 0; i < 10; i++) {
        rePlayerData.currentSlide.seats[i].display.style = rePlayerData.slides[rePlayerData.slideIndex].seats[i].display.style;
        rePlayerData.currentSlide.seats[i].coinStack.style = rePlayerData.slides[rePlayerData.slideIndex].seats[i].coinStack.style;
        rePlayerData.currentSlide.seats[i].displayPicture = rePlayerData.slides[rePlayerData.slideIndex].seats[i].displayPicture;
      }
      this.setState(rePlayerData, () => {
        setTimeout(() => {
          rePlayerData.currentSlide = JSON.parse(JSON.stringify(rePlayerData.slides[rePlayerData.slideIndex]))
          if (rePlayerData.slideIndex == (noOfSlides - 1)) {
            rePlayerData.playStatus = false;
            this.state.wonPlayers.map((player) => {
              if (this.state.wonPlayers.length == 1 && player.cardDtls != null) {
                let wonCards = player.cardDtls.split(' -- ')[1].trim()
                rePlayerData.slides[rePlayerData.slideIndex].dealerCards.map((card) => {
                  if (wonCards.indexOf(card.imgId) === -1) {
                    let oldStyle = document.getElementById(card.imgId).getAttribute("style");
                    document.getElementById(card.imgId).setAttribute("style", "-webkit-filter: blur(3px); filter: blur(3px); " + oldStyle);
                  }
                })
                let seats = rePlayerData.slides[rePlayerData.slideIndex].seats;

                seats[this.getSeatIndexByName(seats, player.name)].cards.map((plyCard) => {
                  if (wonCards.indexOf(plyCard.imgId) === -1) {
                    let oldStyle = document.getElementById(plyCard.imgId).getAttribute("style");
                    document.getElementById(plyCard.imgId).setAttribute("style", "-webkit-filter: blur(3px); filter: blur(3px); " + oldStyle);
                  }
                })
              }
            })
            if (this.props.slideEnded) this.props.slideEnded();
          }
          this.setState(rePlayerData, () => {
            var objDiv = document.getElementById("descpContent");
            if(objDiv){
              objDiv.scrollTop = objDiv.scrollHeight;
            }
          })
        }, 100);
      })
    } else {
      // console.log("No more Slides");
      this.state.rePlayerData.playStatus = false
      this.forceUpdate()
      if (this.props.slideEnded) this.props.slideEnded();
    }
  }

  prevSlide = () => {
    let { rePlayerData } = this.state;
    // console.log(rePlayerData);

    if (rePlayerData.slideIndex > 0) {
      rePlayerData.slideIndex--;
      rePlayerData.currentSlide = JSON.parse(JSON.stringify(rePlayerData.slides[rePlayerData.slideIndex]))
      this.setState(rePlayerData);
      //remove blur logic
      this.state.wonPlayers.map((player) => {
        let wonCards = player.cardDtls.split(' -- ')[1].trim()
        if (this.state.wonPlayers.length == 1) {
          rePlayerData.slides[rePlayerData.slideIndex].dealerCards.map((card) => {
            if (wonCards.indexOf(card.imgId) === -1)
              document.getElementById(card.imgId).setAttribute("style", "padding-right:0.2em; width:20%");
          })
          let seats = rePlayerData.slides[rePlayerData.slideIndex].seats;
          let oldStyle
          if (seats[this.getSeatIndexByName(seats, player.name)].cards.length == 4) {
            oldStyle = "padding-right:0.5em; width: 25%"
          } else {
            oldStyle = "padding-right:0.5em; width: 40%"
          }
          seats[this.getSeatIndexByName(seats, player.name)].cards.map((plyCard) => {
            if (wonCards.indexOf(plyCard.imgId) === -1) {
              document.getElementById(plyCard.imgId).setAttribute("style", oldStyle);
            }
          })
        }
      })
    }

  }

  stepForward = () => {
    if (this.state.stepBackward)
      this.state.stepBackward = false
    if (this.state.rePlayerData.slideIndex != (this.state.rePlayerData.slides.length - 1) && this.state.rePlayerData.slideIndex > 0)
      this.state.stepForward = true
    else
      this.state.stepForward = false
    this.forceUpdate()
    this.pause();
    this.nextSlide()
  }

  stepBackward = () => {
    if (this.state.stepForward)
      this.state.stepForward = false
    if (this.state.rePlayerData.slideIndex > 0)
      this.state.stepBackward = true
    else
      this.state.stepBackward = false
    this.forceUpdate()
    this.pause();
    this.prevSlide();
  }

  play = () => {
    if (this.state.stepBackward || this.state.stepForward || this.state.pause || this.state.refresh || !this.state.play) {
      let activityTrack = []
      let track = {}
      if (localStorage.getItem('activityTrack'))
        activityTrack = JSON.parse(localStorage.getItem('activityTrack'))
      track.hit_timestamp = moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        track.session_id = localStorage.getItem("token")
      track.userid = localStorage.getItem("username")
      track.deviceInfo = JSON.parse(localStorage.getItem("deviceInfo"))
      track.hit_page = 'GameReplayer'
      if (!this.state.play) {
        let access = JSON.parse(localStorage.getItem('userRole'))
        if(!access) {
          track.hit_attribute3 = 'anonymous'
        } else if (access.indexOf('SYS_ADMIN') != -1)
          track.hit_attribute3 = localStorage.getItem('alias') == this.props.playerAlias ? 'Hero' : 'SYS_ADMIN'
        else if (access.indexOf('BUSINESS_OWNER') != -1)
          track.hit_attribute3 = localStorage.getItem('alias') == this.props.playerAlias ? 'Hero' : 'BUSINESS_OWNER'
        else if (access.indexOf('SHIFT_MANAGER') !== -1)
          track.hit_attribute3 = localStorage.getItem('alias') == this.props.playerAlias ? 'Hero' : 'SHIFT_MANAGER'
        else if (access.indexOf('COACH') !== -1)
          track.hit_attribute3 = localStorage.getItem('alias') == this.props.playerAlias ? 'Hero' : 'COACH'
        this.setState({ play: true })
        track.hit_type = 'GameReplayerPlay'
      }
      else if (this.state.stepBackward) {
        this.setState({ stepBackward: false })
        track.hit_type = 'GameReplayerResume'
        track.hit_attribute3 = ''
      }
      else if (this.state.stepForward) {
        this.setState({ stepForward: false })
        track.hit_type = 'GameReplayerResume'
        track.hit_attribute3 = ''
      }
      else if (this.state.pause) {
        this.setState({ pause: false })
        track.hit_type = 'GameReplayerResume'
        track.hit_attribute3 = ''
      }
      else if (this.state.refresh) {
        this.setState({ refresh: false })
        track.hit_type = 'GameReplayerReplay'
        track.hit_attribute3 = ''
      }
      track.hit_attribute1 = this.props.gameNo
      track.hit_attribute2 = this.props.playerAlias
      track.hit_attribute4 = ''
      track.hit_attribute5 = ''
      activityTrack.push(track)
      localStorage.setItem('activityTrack', JSON.stringify(activityTrack))
    }
    let { rePlayerData } = this.state;
    rePlayerData.playStatus = true;
    if (rePlayerData.slideIndex == (rePlayerData.slides.length - 1)) this.refresh()
    else
      // this.nextSlide();
      this.continue();
  }

  pause = () => {
    if (!this.state.stepBackward && !this.state.stepForward && !this.state.refresh)
      if (this.state.rePlayerData.slideIndex != (this.state.rePlayerData.slides.length - 1))
        this.state.pause = true
      else
        this.state.pause = false
    if ((this.state.stepBackward || this.state.stepForward || this.state.pause) && !this.state.refresh && this.state.rePlayerData.slideIndex > 0) {
      let activityTrack = []
      let track = {}
      if (localStorage.getItem('activityTrack'))
        activityTrack = JSON.parse(localStorage.getItem('activityTrack'))
      track.hit_timestamp = moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        track.session_id = localStorage.getItem("token")
      track.userid = localStorage.getItem("username")
      track.deviceInfo = JSON.parse(localStorage.getItem("deviceInfo"))
      track.hit_page = 'GameReplayer'
      track.hit_attribute1 = this.props.gameNo
      track.hit_attribute2 = this.props.playerAlias
      track.hit_attribute3 = ''
      track.hit_attribute4 = ''
      track.hit_attribute5 = ''
      if (this.state.stepForward)
        track.hit_type = 'GameReplayerNextStep'
      else if (this.state.stepBackward)
        track.hit_type = 'GameReplayerPrevStep'
      else if (this.state.pause) {
        track.hit_type = 'GameReplayerPause'
      }
      activityTrack.push(track)
      localStorage.setItem('activityTrack', JSON.stringify(activityTrack))
    }

    let rePlayerData = this.state.rePlayerData;
    rePlayerData.playStatus = false
    this.setState(rePlayerData)
  }

  openShareDialog = () => {
    saveActivity({
      hit_page: 'HandReplayer',
      hit_type: 'ShareReplayerOpen',
      hit_attribute1: this.props.gameTypeForTitle,
      hit_attribute2: this.props.gameNo,
      hit_attribute3: this.props.playerAlias,
    })
    this.setState({isShareDialogOpen: true})
  }

  closeShareDialog= () => {
    this.setState({isShareDialogOpen: false})
  }
  render() {
   // console.log("HAND REPLAY",this.state)
    const {
      smallBlind,
      bigBlind,
    } = this.state;
    const {
      gameNo,
      gameTypeForTitle,
      playerAlias,
      partitionDate
    } = this.props
    let slide = this.generateEmptySlide();
    if (this.state.rePlayerData.slides.length > 0) {
      slide = this.state.rePlayerData.currentSlide;
    }

    let seat1, seat2, seat3, seat4, seat5, seat6, seat7, seat8, seat9, seat10;
    seat1 = slide.seats[0];
    seat2 = slide.seats[1];
    seat3 = slide.seats[2];
    seat4 = slide.seats[3];
    seat5 = slide.seats[4];
    seat6 = slide.seats[5];
    seat7 = slide.seats[6];
    seat8 = slide.seats[7];
    seat9 = slide.seats[8];
    seat10 = slide.seats[9];
    
    return (
      <div>
        {this.state.loading ? <Loading /> : null}
        <Media query="(max-width: 849px)">
          {matches => matches ? (
            <MobileReplayer
              replayerScreen={this.props.replayerScreen}
              loginStatus={this.props.loginStatus}
              onShareDialogClose={this.onShareDialogClose}
              onShareDialogOpen={this.onShareDialogOpen}
              pause={this.pause}
              play={this.play}
              onClose={this.props.onClose}
              gameTypeForTitle={this.props.gameTypeForTitle}
              playStatus={this.state.rePlayerData.playStatus}
              refresh={this.refresh}
              shareDialog={this.state.shareDialog}
              smallBlind={smallBlind}
              bigBlind={bigBlind}
              gameNo={gameNo}
              currency={this.state.currency}
              isShareDialogOpen={this.state.isShareDialogOpen}
              closeShareDialog={this.closeShareDialog}
              openShareDialog={this.openShareDialog}
              playerAlias={playerAlias}
              allBlinds={this.state.allBlinds}
              shareParams={{
                data: { gameNo: this.state.gameNo, playerAlias: this.state.playerAlias },
                type: this.state.shareType
              }}
              shareURL={this.state.shareURL}
              slide={slide}
              stepBackward={this.stepBackward}
              stepForward={this.stepForward}
              partitionDate={partitionDate}
              accountName={this.props.accountName}
              slideIndex={this.state.rePlayerData.playStatus == false ? this.state.rePlayerData.slideIndex : '' }
              booster={this.state.booster}
              boosterAmount={this.state.boosterAmount}
              boosterType={this.state.boosterType}
              slideLength={this.state.rePlayerData.slides.length}
              boosterImages={boosterImages}
            />
          ) : (
              <DesktopReplayer
                replayerScreen={this.props.replayerScreen}
                loginStatus={this.props.loginStatus}
                onShareDialogClose={this.onShareDialogClose}
                onShareDialogOpen={this.onShareDialogOpen}
                pause={this.pause}
                play={this.play}
                onClose={this.props.onClose}
                currency={this.state.currency}
                gameTypeForTitle={this.props.gameTypeForTitle}
                playStatus={this.state.rePlayerData.playStatus}
                refresh={this.refresh}
                shareDialog={this.state.shareDialog}
                shareParams={{
                  data: { gameNo: this.state.gameNo, playerAlias: this.state.playerAlias },
                  type: this.state.shareType
                }}
                shareURL={this.state.shareURL}
                smallBlind={smallBlind}
                bigBlind={bigBlind}
                gameNo={gameNo}
                isShareDialogOpen={this.state.isShareDialogOpen}
                closeShareDialog={this.closeShareDialog}
                openShareDialog={this.openShareDialog}
                playerAlias={playerAlias}
                allBlinds={this.state.allBlinds}
                trackData={{
                  session_id: localStorage.getItem("token"),
                  userid: localStorage.getItem("username"),
                  deviceInfo: JSON.parse(localStorage.getItem("deviceInfo")),
                  hit_page: 'handreplayer',
                  hit_type: 'handreaplayershare',
                  hit_attribute2: this.state.gameNo,
                  hit_attribute3: '',
                  hit_attribute4: '',
                  hit_attribute5: '',
                }}
                slide={slide}
                accountName={this.props.accountName}
                stepBackward={this.stepBackward}
                stepForward={this.stepForward}
                partitionDate={partitionDate}
                slideIndex={this.state.rePlayerData.playStatus == false ? this.state.rePlayerData.slideIndex : '' }
                booster={this.state.booster}
                boosterAmount={this.state.boosterAmount}
                boosterType={this.state.boosterType}
                slideLength={this.state.rePlayerData.slides.length}
                boosterImages={boosterImages}
              />
            )}
        </Media>
      </div>
    )
  }

}

// HandReplayer.defaul



/** WEBPACK FOOTER **
 ** ./src/components/HandReplayer/HandReplayer.js
 **/